<script>

import MaskedInput from 'vue-masked-input'

/**
 *  All properties are passed to input as DOM attributes.
 */
export default {
  name: 'Textbox',
  components: {
    MaskedInput
  },
  props: {
    autocomplete: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    id: String,
    name: {
      type: String,
      default: ''
    },
    value: {
      type: [ String, Number ],
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    maxlength: String,
    mask: [ String, Object ],
    readonly: [ String, Boolean ],
    placeholderChar: {
      type: String,
      default: ' '
    },
    multiline: {
      default: false
    },
    font: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    before: {
      type: String
    },
    validator: {
      type: Object
    }
  },
  data () {
    return {
      val: this.value
    }
  },
  methods: {
    update (event, value) {
      if (!this.mask) {
        value = event.target.value
      }
      this.$emit('input', value)
      if (this.validator && this.validator.$dirty) {
        this.touch()
      }
    },
    focus () {
      this.$el.lastChild.focus()
    },
    touch () {
      this.validator.$touch()
    },
    blur () {
      this.touch()
      this.$emit('blur')
    }
  },
  computed: {
    tag () {
      return this.multiline ? 'textarea' : 'input'
    },
    error () {
      return this.validator.$error
    }
  }
}

</script>

<template lang="pug">

.input
  .before(v-if="before", v-text="before")
  masked-input(
    v-if="mask",
    :class="{ error, [size]: size, [font]: font }",
    :id="id",
    :name="name",
    :maxlength="maxlength",
    :mask="mask",
    :placeholder-char="placeholderChar",
    v-model="val",
    @input="update",
    @blur.native="blur",
    @blur="blur",
    @focus="$emit('focus')"
  )
  component(
    v-else,
    :is="tag",
    :class="{ error, [size]: size, [font]: font }",
    :type="type",
    :autocomplete="autocomplete",
    :placeholder="placeholder",
    :id="id",
    :name="name",
    :maxlength="maxlength",
    :value.prop="value",
    :disabled="disabled",
    :readonly="readonly",
    @input="update",
    @blur.native="blur",
    @blur="blur",
    @focus="$emit('focus')"
  )

</template>

<style scoped lang="sass">

.input
  position: relative

.before
  position: absolute
  left: 0
  top: 0
  width: 50%
  height: 24px
  line-height: 24px
  text-align: right
  font-size: 12px
  font-weight: $light
  & + input
    padding-left: 50%

input, textarea
  $border-width: 1px
  display: block
  width: 100%
  padding: 0 5px
  height: 24px
  border: $border-width solid #D2D2D2
  font-size: $small-font-size
  outline: 0
  transition: $transition-time border-color $transition-timing
  box-shadow: none
  border-radius: 2px
  &.normal
    padding: 0 10px
    height: 32px
    font-size: 16px
  &.big
    height: 42px
    padding: 0 15px
    font-size: 24px
    letter-spacing: 4px
  &.light
    font-size: 12px
    font-weight: $light
  &:focus
    border-color: #00B4DB
  &.error
    border-color: $red
  &::placeholder
    color: #CECECE

textarea
  height: auto
  min-height: 150px
  padding: 10px 5px

</style>
